<template>
  <div>

    <CCard>
      <CCardBody>
        <CRow>
          <CCol sm="5">
            <h4 id="traffic" class="card-title mb-0">Bestellungen</h4>
            <div class="small text-muted">November 2020</div>
          </CCol>
          <CCol sm="7" class="d-none d-md-block">
            <CButton color="primary" class="float-right">
              <CIcon name="cil-cloud-download"/>
            </CButton>
            <CButtonGroup class="float-right mr-3">
              <CButton
                color="outline-secondary"
                v-for="(value, key) in ['Tag', 'Monat', 'Jahr']"
                :key="key"
                class="mx-0"
                :pressed="value === selected ? true : false"
                @click="selected = value"
              >
                {{value}}
              </CButton>
            </CButtonGroup>
          </CCol>
        </CRow>

      </CCardBody>

    </CCard>
    
    
  </div>
</template>

<script>

export default {
  name: 'Dashboard',
  components: {
        
  },
  data() {
    return {
      secretMessage: '',
      username: ''
    };
  },
  methods: {
    logout: function () {
      this.$store.dispatch(AUTH_LOGOUT)
      .then(() => {
        this.$router.push('/login')
      })
    }
  } 
}
</script>